export default "__VITE_ASSET__B2gesJlg__"